import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Utility: Convert FontAwesome icon to base64 PNG
export function iconToBase64(icon, size = 32, color = "black") {
  const svgString = renderToStaticMarkup(
    createElement(FontAwesomeIcon, { icon, size: "lg", color })
  );

  const svg = new Blob([svgString], { type: "image/svg+xml" });
  const url = URL.createObjectURL(svg);

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, size, size);
      resolve(canvas.toDataURL("image/png"));
    };
    img.src = url;
  });
}
